import { Env, getEnv } from './env';

export function initializeFm() {
    const env = getEnv();

    window._fmOpt = {
        partner: 'nio',
        // 'hana' | 'apollo-h5'
        appName: 'hana',
        // stg https://palm-stg.nio.com
        // prod https://palm.nio.com
        fpHost:
            env === Env.prod
                ? 'https://palm.nio.com'
                : 'https://palm-stg.nio.com',
        success: function(data) {
            // 在成功完成采集后，success回调中可以获取到black_box
            // 这⾥里里可以设置客户需求的操作，传输black_box等操作
            // 获取设备指纹⿊黑盒数据，并提交到业务服务器
            console.log('[env]', env, 'blackBox', data);
        }
    };
    const fm = document.createElement('script');

    fm.type = 'text/javascript';
    fm.async = true;
    // 一小时浏览器器缓存（可根据需求⾃行修改缓存时间）
    fm.src =
        window._fmOpt.fpHost +
        '/static/fm.js?t=' +
        (new Date().getTime() / 3600000).toFixed(0);
    const s = document.getElementsByTagName('script')[0];

    s.parentNode && s.parentNode.insertBefore(fm, s);
}

// 获取blackbox
// window.tdblackbox || (window._fmOpt.getinfo ? window._fmOpt.getinfo() || '' : '')
// tdblackbox 是啥我也不知道
export function getBlackBox() {
    return (
        (window._fmOpt && window._fmOpt.getinfo && window._fmOpt.getinfo()) ||
        ''
    );
}



// WEBPACK FOOTER //
// ./src/util/fm.js